export const environment = {
  production: false,
  apiBase: 'http://127.0.0.1:5001/tt-digital-vcard-dev/asia-south1/api/api',
  appcheck: {
    siteKey: '6LdT1vYrAAAAAIs4UCM-Kyor8eeSyk7QcRhgaCR8',
  },
  firebase: {
    projectId: 'tt-digital-vcard-dev',
    appId: '1:835547657827:web:91aafc912bb079f4056a56',
    storageBucket: 'tt-digital-vcard-dev.firebasestorage.app',
    apiKey: 'AIzaSyDvocB6-A-ZE8-qARvOBFYROEXIzn7J68o',
    authDomain: 'tt-digital-vcard-dev.firebaseapp.com',
    messagingSenderId: '835547657827',
    measurementId: 'G-G9DKCZQB2B',
  },
};
